<template>
    <Badge
        v-if="
            [
                AutomationStateEnum.Enabled,
                AutomationStateEnum.Disabled,
            ].includes(state)
        "
        class="inline-flex"
        :color="state === AutomationStateEnum.Enabled ? 'info' : 'secondary'"
    >
        <div class="">
            <template v-if="state === AutomationStateEnum.Enabled">
                Enabled
            </template>
            <template v-else-if="state === AutomationStateEnum.Disabled">
                Disabled
            </template>
        </div>
    </Badge>
</template>

<script setup lang="ts">
    import type { PropType } from 'vue'
    import Badge from '@/Shared/Component/Badge.vue'
    import { AutomationStateEnum } from '@/Shared/AutoGenerated/Main'

    const props = defineProps({
        state: {
            type: String as PropType<AutomationStateEnum>,
            required: true,
        },
    })
</script>
